import React, {useState} from 'react';
import {useTranslation} from 'react-i18next';
import {AxiosError} from 'axios';
import classNames from 'classnames';
import {httpGetWithHeaders} from '../../../service/http.service';
import Card from '../../components/common/Card';
import Button from '../../../incase-domain/components/button/Button';
import {type TypedTranslation} from '../../../i18n';

function ExcelReport(): JSX.Element {
    const {t} = useTranslation();
    const [presentationId, setPresentationId] = useState<string>('');
    const [error, setError] = useState<TypedTranslation | ''>('');

    const handleDownloadExcel = async (): Promise<void> => {
        try {
            const response = await httpGetWithHeaders(`admin/analytics/exportExcel/${presentationId}`, {responseType: 'blob'});

            const url = window.URL.createObjectURL(new Blob([response.data]));
            const filename = response.headers['x-filename'] || 'report.xlsx';

            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', filename);

            document.body.appendChild(link);
            link.click();
            link.parentNode?.removeChild(link);
        } catch (e) {
            if ((e as AxiosError).response?.status === 404) {
                setError('reportsPage.presentationNotFound');
            }
        }
    };

    return (
        <Card header={t('reportsPage.header')}>
            <div className="c-reports__container">
                <div className={classNames('c-field', {'is-invalid': error})}>
                    <label>
                        {t('reportsPage.presentationId')}
                        <div className="c-control">
                            <input
                                type="text"
                                className="e-input"
                                placeholder={t('reportsPage.presentationId')}
                                value={presentationId}
                                onChange={(e) => setPresentationId(e.target.value)}
                            />
                        </div>
                    </label>
                </div>
                <Button size="sm" variant="solid" color="secondary" onClick={handleDownloadExcel} disabled={!presentationId}>
                    {t('reportsPage.getReports')}
                </Button>
            </div>
            {error && <div className="c-form-help is-invalid is-invalid--show">{t(error)}</div>}
        </Card>
    );
}

export default ExcelReport;
